import { createContext, useContext } from 'react';

// El contexto de sesión y su hook, fuera del archivo del proveedor.
//
// No es purismo: un archivo que exporta un componente Y otras cosas rompe
// la recarga en caliente de Vite para todo el archivo, y `auth.jsx` es de
// los que más se tocan. Vive en `lib/` porque es exactamente lo que hay
// ahí: módulos sin componentes (`roles.js`, `cola.js`, `uuidv7.js`).
export const ContextoAuth = createContext(null);

export function useAuth() {
  const ctx = useContext(ContextoAuth);
  if (!ctx) throw new Error('useAuth debe usarse dentro de ProveedorAuth');
  return ctx;
}
